import { NgModule } from '@angular/core';
import { DocumentViewerModule } from './document-viewer/document-viewer.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { TransactionModule } from './transaction/transaction.module';
import { DialogModule } from './dialog/dialog.module';
import { ThemedImageModule } from './themed-image/themed-image.module';

@NgModule({
  declarations: [],
  imports: [
    DocumentViewerModule,
    SharedModule,
    LayoutModule,
    TransactionModule,
    DialogModule,
    ThemedImageModule,
  ],
  exports: [
    SharedModule,
    DocumentViewerModule,
    LayoutModule,
    TransactionModule,
    DialogModule,
    ThemedImageModule,
  ],
})
export class NgxMatEsign360Module {}
